<div class="space"></div>
<!-- MAIN -->
<main>
    <!-- ARTICLE BLOG POST -->
    <section class="articles articles-blog-post">
        <article class="articles-blog-post" *ngFor="let data of datas; index as i">
            <div class="container">
                <div class="row">
                    <div class="col-lg-9 col-xs-12">
                        <!-- AddToAny BEGIN -->

    <!-- AddToAny END -->
                        <!-- TEXT ARTICLE -->
                        <div class="articles-header">
                            <div class="box">
                                <time datetime="2016-10-11">{{ data.date | date:'dd/MM/yyyy' }}</time>
                            </div>
                            <div class="box">
                                <a [routerLink]="['/blog']">
                                    <div class="back">
                                        <img class="garrow" src="../../../../../assets/img/blog/detalles/g10arrow.svg" alt="volver">
                                        volver
                                    </div> 
                                </a>
                            </div>
                        </div>
                        <div class="articles-content">
                            <h1 class="articles-content-blog-post-title"><a title="Tendencias de Transformacion Digital">{{ data.title.rendered }}</a></h1>
                            <div class="bloghtml">
                              <div [innerHTML]="data.content.rendered"></div>
                            </div>
                            <div class="articles-content-block">
                            </div>
                        </div>
                        <h5>Compartir:</h5>
                        <a class="twitter-share-button" target="_blank" rel="noopener noreferrer"
                        href="https://www.facebook.com/sharer/sharer.php?u={{ currenturl }}"
                        data-size="large"> 
                        <img class="blue" src="../../assets/img/media/facebookshare.png" alt=""> </a>
                        <a class="twitter-share-button" target="_blank" rel="noopener noreferrer"
                        href="https://twitter.com/intent/tweet?text={{ currenturl }}"
                        data-size="large"> 
                        <img class="blue" src="../../assets/img/media/twittershare.webp" alt=""> </a>
                        <a class="twitter-share-button" target="_blank" rel="noopener noreferrer"
                        href="http://www.linkedin.com/shareArticle?mini=true&url={{ currenturl }}"
                        data-size="large"> 
                        <img class="blue" src="../../assets/img/media/linkedinshare.png" alt=""> </a>

                        <h5>Tambien le puede interesar:</h5><br>
                        <div class="card-deck" >
                          <div *ngFor="let data of topnews; index as i"
                          class="mylink">
                            <div class="card minsize" style="max-width: 250px !important;">
                              <img class="card-img-top imgsize" [routerLink]="['/pagina', data.id, data.slug]" (click)="reload(data.slug)" src="{{ data._embedded['wp:featuredmedia']['0'].source_url }}" alt="Card image cap">
                              <div class="card-body">
                                <h5 class="card-title" [routerLink]="['/pagina', data.id, data.slug]" (click)="reload(data.slug)">{{ data.title.rendered }}</h5>
                              </div>
                              <div class="card-footer">
                                <small class="text-muted">{{ data.date | date: "dd/MM/yyyy" }}</small>
                              </div>
                            </div>
                          </div>
                        </div>

                    </div>
                    <div class="col-lg-3 col-xs-12">
                        <div class="articles-blog-post-share">
                          <aside class="author">
                            <div class="barra">
                              <h2>Publicaciones Relevantes</h2>
                              <ul *ngFor="let data of novedades; index as i">
                               <li class="nav-elipse-blue">
                                 <a
                                 [routerLink]="['/pagina', data.id, data.slug]"
                                   title="{{ data.title.rendered }}"
                                   >{{ data.title.rendered }}</a
                                 >
                               </li>
                             </ul>
                            </div>
                          </aside>
                              <aside class="author">
                                <div class="barra">
                                    <h2>Categorias</h2>
                                    <ul *ngFor="let categorie of categories; index as i">
                                      <li class="nav-elipse-blue">
                                        <a
                                          [routerLink]="['/categorias', categorie.id]"
                                          title="{{ categorie }}"
                                          >{{ categorie.name }}</a
                                        >
                                      </li>
                                    </ul>
                                </div>

                              </aside>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    </section>
    <!-- end ARTICLE BLOG POST -->
    <!-- ARTICLE BOTTOM INFO -->
    <div class="articles-info">
    </div>
    <!-- end ARTICLE BOTTOM INFO -->
</main>
<iframe [src]="current_url" height="600" width="1000" style="display: none;"></iframe>
<!-- end MAIN -->
